import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { appRoutes } from "./routes";
import NotFound from "./pages/NotFound";

const AppRoutes = ({ access }) => (
  <Suspense fallback={<div style={{ padding: 24 }}>Loading...</div>}>
    <Routes>
      {appRoutes.map((r) => (
        <Route key={r.path} path={r.path} element={React.cloneElement(r.element, { access })} />
      ))}
      <Route path="/home" element={<Navigate to="/" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Suspense>
);

export default AppRoutes;
